import { render, staticRenderFns } from "./admuser.vue?vue&type=template&id=dea7fcce&scoped=true&"
import script from "./admuser.vue?vue&type=script&lang=js&"
export * from "./admuser.vue?vue&type=script&lang=js&"
import style0 from "./admuser.vue?vue&type=style&index=0&id=dea7fcce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea7fcce",
  null
  
)

export default component.exports